export default __webpack_public_path__ + "static/media/profilePic.1393f509.svg";